import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { messages } from '../../../../../messages';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseTextElement, toFormattedTextProps } from '../common';
var ModifiedByElement = function ModifiedByElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toFormattedTextProps(messages.modified_by, context.modifiedBy) : null;
  return data ? /*#__PURE__*/React.createElement(BaseTextElement, _extends({}, data, props, {
    name: ElementName.ModifiedBy
  })) : null;
};
export default ModifiedByElement;